// App.jsx
import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TopNavbar from './components/TopNavBar/TopNavBar';
import Footer from './components/Footer/Footer';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/i18n';
import { routes } from './routes/routes';
import { ProtectedRoute } from './components/ProtectedRoute/ProtectedRoute';
import KeycloakProviderWrapper from './keycloak/KeycloakProviderWrapper';
import { useAppKeycloak } from './keycloak/keycloakUtils';
import Container from 'react-bootstrap/esm/Container';
import { useLocation } from 'react-router-dom';
import { ServiceFactory } from './Api/Services/ServiceFactory';
import { ToastProvider, useToast } from './components/ToastContext/ToastContext';
import GlobalErrorHandler from './GlobalError/GlobalErrorHandler';
import { Provider } from 'react-redux';
import appConfig from './config/config';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPersonBundle } from './store/slices/personSlice';
import { useTranslation } from 'react-i18next';

const AppContent = () => {
  const [title, setTitle] = useState('');
  const location = useLocation();
  const [factoryInitialized, setFactoryInitialized] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    // Trova il titolo in base alla route attuale
    const currentRoute = routes.find((route) => route.path === location.pathname);
    setTitle(currentRoute?.title || '');
  }, [location]);

  useEffect(() => {
    ServiceFactory.initialize((key, options) => i18n.t(key, options))
      .then(() => { setFactoryInitialized(true); }) // La factory è inizializzata
      .catch((error) => {
        console.error('Errore durante l\'inizializzazione della ServiceFactory:', error);
        // Evita che l'errore venga propagato al GlobalErrorHandler
      });
  }, []);

  const dispatch = useDispatch();
  const person = useSelector(state => state.person.person);
  const loading = useSelector(state => state.person.loading);
  const userData = useSelector(state => state.person.userData);
  const userDataLoading = useSelector(state => state.person.userDataLoading);
  const { initialized, keycloak } = useAppKeycloak();
  const authenticated = keycloak?.authenticated;
  useEffect(() => {
    if (!initialized || !factoryInitialized || !authenticated) {
      return; // Non fare nulla finché i servizi non sono inizializzati e l'utente non ha fatto login
    }

    const isDataComplete = !!person && !!userData;
    const isLoading = loading || userDataLoading;

    if (!isDataComplete && !isLoading) {
      dispatch(fetchPersonBundle());
    }
  }, [dispatch, person,
    userData, loading,
    userDataLoading, initialized,
    factoryInitialized, authenticated]);

  if (!initialized || !factoryInitialized) {
    return <div>{t("app:labels.loading")}</div>;
  }

  return (
    <Container className='d-flex flex-column vh-100' fluid style={{ padding: '0px' }}>
      <TopNavbar title={title} />

      <Routes>
        {routes.map(({ path, element: Component, protected: isProtected, roles }, index) => (
          <Route
            key={index}
            path={path}
            element={
              isProtected ? (
                <ProtectedRoute roles={roles} component={Component} />
              ) : (
                <Component />
              )
            }
          />
        ))}
      </Routes>

      <Footer />
    </Container>
  );
};

const YaWrapper = () => {
  const { showToast } = useToast();

  useEffect(() => {
    GlobalErrorHandler(showToast);
  }, []);

  return (
    <Router basename={appConfig.ROUTER_BASENAME}>
      <AppContent />
    </Router>
  );
};

const App = () => {

  return (
    <div className="app">
      <KeycloakProviderWrapper>
        <I18nextProvider i18n={i18n}>
          <ToastProvider>

            <YaWrapper />

          </ToastProvider>
        </I18nextProvider>
      </KeycloakProviderWrapper>
    </div>
  );
};

export default App;